import { ADMIN_ROLE } from '@wingwork/common/src/constants/permissions'
import { useAuth } from 'src/auth'

const useIsAdmin = () => {
  const { hasRole } = useAuth()
  return hasRole(ADMIN_ROLE)
}

export default useIsAdmin
